import { NgModule, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { Login } from './pages/auth/login/login';
import { VerificationDialog } from './pages/auth/verification-dialog/verification-dialog';
import { Main } from './layout/main/main';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './component/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { NgOtpInputModule } from 'ng-otp-input';
import { ToastrModule } from 'ngx-toastr';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
import { WorkInProgress } from './shared/work-in-progress/work-in-progress';
import { ChangePasswordVerificationDialog } from './pages/auth/change-password-verification-dialog/change-password-verification-dialog';
import { RecaptchaWidgetComponent } from './component/recaptcha-widget/recaptcha-widget';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PermissionRealtimeService } from './services/permission-service/permission-realtime.service';

@NgModule({
  declarations: [
    App,
    Login,
    Main,
    VerificationDialog,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    WorkInProgress,
    ChangePasswordVerificationDialog,
    RecaptchaWidgetComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    NgOtpInputModule,
    SharedModule,
    ToastrModule.forRoot({ closeButton: true }),
    NgxSpinnerModule.forRoot({ type: 'square-jelly-box' }),
    CKEditorModule
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Real-time role/permission updates: connects while an admin is signed in.
    provideAppInitializer(() => { inject(PermissionRealtimeService); }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [App]
})
export class AppModule { }